import redbreaker from './images/rewa_redbreaker.png'
import greenbreaker from './images/greenbreaker.png'
import sld from './images/shivnala_SLD.png'
import { useState , useEffect, useRef} from 'react'
import SldPopUp from './SldPopUp'
import ApiService from "../../services/apiService";
import yellowbreaker from './images/yellowbreaker.png';
import { Maximize, Minimize } from "react-feather";
import LoadingComponent from "../lodingComponent";
import whitebreaker from './images/whitebreaker.png'
 const SLD = () =>{
    
      const targetRef = useRef<HTMLDivElement>(null);
      const[loading,setloading] = useState<Boolean>(true)
      const[selectedbreakerName, setSelectedBreakerName] = useState<string | null>(null);
      const [breakerOpen, setBreakerOpen] = useState(false);
     const [fullScreen, setFullScreen] = useState(false);
      const [PumpData, setpumpdata] = useState<any[]>([]);
      const getAllPumpingStations = async () => {
    try {
      const response = await ApiService.axiosApi(`/tags`, {
        method: "GET",
      });

      if (response.success) {
        console.log(response.data);
        setpumpdata(response.data);
        setloading(false)
        console.log("Fetched all pumping stations successfully");
      } else {
        console.error("Failed to fetch pumping stations");
      }
    } catch (error) {
      console.error("Error fetching pumping stations:", error);
      console.log("Error fetching pumping stations");
    }
  };


  useEffect(() => {
    getAllPumpingStations();
  
    // Move setInterval inside useEffect
    const interval = setInterval(() => {
      getAllPumpingStations();
    }, 1000); 
  
    // Cleanup interval on unmount
    return () => clearInterval(interval);
  }, []); // keep dependency array
  
const openBreaker = (breakerName: string) => {
   setSelectedBreakerName(breakerName);
    console.log(breakerName)
   setBreakerOpen(true);
  };

  const closeBreaker = () => setBreakerOpen(false);
   const fullScreenHandler = async () => {
       try {
         if (!fullScreen) {
           if (targetRef.current && targetRef.current.requestFullscreen) {
             await targetRef.current.requestFullscreen();
           }
         } else {
           if (document.fullscreenElement && document.exitFullscreen) {
             await document.exitFullscreen();
           }
         }
       } catch (err) {
         console.error("Fullscreen error:", err);
       }
     };
   
     useEffect(() => {
       const handleFullScreenChange = () => {
         setFullScreen(!!document.fullscreenElement);
       };
       document.addEventListener("fullscreenchange", handleFullScreenChange);
       return () => document.removeEventListener("fullscreenchange", handleFullScreenChange);
     }, []);
      


    return(
         <>
          {loading?  <LoadingComponent/> :<>  <div ref={targetRef} className="sld-structure-wrapper">

            <li
              style={{
                position: "absolute",
                top: "4.5%",
                left: "3%",
                listStyle: "none",
                backgroundColor: "whitesmoke",
                height: "30px",
                width: "30px",
                borderRadius: "6px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                transition: "all 0.2s ease-in-out",
                padding: 0,
                zIndex : 1000
              }}
              onClick={fullScreenHandler}
            >
              {fullScreen ? <Minimize size={18} /> : <Maximize size={18} />}
            </li> 

         <div className="diagram-container-pump" style={{
           
         }}>
  
  <div className="sld-wrapper ">
    <img src={sld} alt="SLD Diagram" className="SLD-Diagram"/>
  </div>
{["INC1_33KV"].map((breakerName) => {
  const tags = PumpData.filter((t: any) => t.name.startsWith(breakerName));
  const onTag = tags.find(t => t.name === `${breakerName}_ON`);
  const tripTag = tags.find(t => t.name === `${breakerName}_ANYFLT`);
  const offTag = tags.find(t => t.name === `${breakerName}_OFF`);
console.log(onTag)
let imgSrc =
  onTag?.value === "True" && offTag?.value==="False" && tripTag?.value === "False"
    ? greenbreaker
    : tripTag?.value === "True"
    ? yellowbreaker
    : offTag?.value === "True" && onTag?.value === "False"&& tripTag?.value === "False"
    ? redbreaker
    : offTag?.value === "False" && onTag?.value === "False"&& tripTag?.value === "False"
    ?whitebreaker
    : redbreaker; // default (if none matches)

  

  return (
    <div key={breakerName} className="greenbreaker-wrapper">
      <img
        src={imgSrc?imgSrc:redbreaker}
        alt={`Green Breaker ${breakerName}`}
        className="greenbreaker1-pump"
        style={{ left: '50%', position: 'absolute' }}
      />
    </div>
  );
})}

{["LT1"].map((breakerName)=>{

   const tags = PumpData.filter((t: any) => t.name.startsWith(breakerName));
  const onTag = tags.find(t => t.name === `${breakerName}_ON`);
  const tripTag = tags.find(t => t.name === `${breakerName}_ANYFLT`);
  const offTag = tags.find(t => t.name === `${breakerName}_OFF`);
console.log(onTag)
let imgSrc =
  onTag?.value === "True" && offTag?.value==="False" && tripTag?.value === "False"
    ? greenbreaker
    : tripTag?.value === "True"
    ? yellowbreaker
    : offTag?.value === "True" && onTag?.value === "False"&& tripTag?.value === "False"
    ? redbreaker
    : offTag?.value === "False" && onTag?.value === "False"&& tripTag?.value === "False"
    ?whitebreaker
    : redbreaker; // default (if none matches)

    
     return(
    <div>
    <img src={imgSrc} alt="Green Breaker2" className="greenbreaker2-pump"style={{
         left:'71.2%',
         top:'65%'
    }}/>
    </div>
     )
 })}

 
{["BC_6_6KV"].map((breakerName) => {
  const tags = PumpData.filter((t: any) => t.name.startsWith(breakerName));
  const onTag = tags.find(t => t.name === `${breakerName}_ON`);
  const tripTag = tags.find(t => t.name === `${breakerName}_ANYFLT`);
  const offTag = tags.find(t => t.name === `${breakerName}_OFF`);

  let imgSrc =
    onTag?.value === "True" && offTag?.value === "False" && tripTag?.value === "False"
      ? greenbreaker
      : tripTag?.value === "True"
      ? yellowbreaker
      : offTag?.value === "True" && onTag?.value === "False" && tripTag?.value === "False"
      ? redbreaker
      : offTag?.value === "False" && onTag?.value === "False" && tripTag?.value === "False"
      ? whitebreaker
      : redbreaker;

  return (
    <div key={breakerName}>
      <img
        src={imgSrc}
        alt={breakerName}
        className="greenbreaker3-pump"
        style={{ left: '40.2%', top: '53.7%' }}
      />
    </div>
  );
})}

  </div>

   
{["INC1_6_6KV"].map((breakerName)=>{
     const tags = PumpData.filter((t: any) => t.name.startsWith(breakerName));
     const onTag = tags.find(t => t.name === `${breakerName}_ON`);
  const tripTag = tags.find(t => t.name === `${breakerName}_ANYFLT`);
  const offTag = tags.find(t => t.name === `${breakerName}_OFF`);
console.log(onTag)
let imgSrc =
  onTag?.value === "True" && offTag?.value==="False" && tripTag?.value === "False"
    ? greenbreaker
    : tripTag?.value === "True"
    ? yellowbreaker
    : offTag?.value === "True" && onTag?.value === "False"&& tripTag?.value === "False"
    ? redbreaker
    : offTag?.value === "False" && onTag?.value === "False"&& tripTag?.value === "False"
    ?whitebreaker
    : redbreaker; // default (if none matches)

    return(
  <div className="redbreaker-wrapper">
    <img src={imgSrc?imgSrc:redbreaker} alt="Red Breaker1" className="rewa_redbreaker1-pump"style={{
         top:'48%',
             left: '25.2%',
             position : 'absolute'
    }} />
    </div>
    )
 })}

 {["INC2_6_6KV"].map((breakerName)=>{
      const tags = PumpData.filter((t: any) => t.name.startsWith(breakerName));
     const onTag = tags.find(t => t.name === `${breakerName}_ON`);
  const tripTag = tags.find(t => t.name === `${breakerName}_ANYFLT`);
  const offTag = tags.find(t => t.name === `${breakerName}_OFF`);
console.log(onTag)
let imgSrc =
  onTag?.value === "True" && offTag?.value==="False" && tripTag?.value === "False"
    ? greenbreaker
    : tripTag?.value === "True"
    ? yellowbreaker
    : offTag?.value === "True" && onTag?.value === "False"&& tripTag?.value === "False"
    ? redbreaker
    : offTag?.value === "False" && onTag?.value === "False"&& tripTag?.value === "False"
    ?whitebreaker
    : redbreaker; // default (if none matches)

    return(
 <div>
    <img src={imgSrc?imgSrc:redbreaker} alt="Red Breaker2" className="rewa_redbreaker2-pump"style={{
         top:'48%',
         left: '54.6%',
          position : 'absolute'
    }}  />
    </div>
    )
 })}

{["PMP1"].map((breakerName)=>{
     const tags = PumpData.filter((t: any) => t.name.startsWith(breakerName));
     const onTag = tags.find(t => t.name === `${breakerName}_ON`);
  const tripTag = tags.find(t => t.name === `${breakerName}_ANYFLT`);
  const offTag = tags.find(t => t.name === `${breakerName}_OFF`);
console.log(onTag)
let imgSrc =
  onTag?.value === "True" && offTag?.value==="False" && tripTag?.value === "False"
    ? greenbreaker
    : tripTag?.value === "True"
    ? yellowbreaker
    : offTag?.value === "True" && onTag?.value === "False"&& tripTag?.value === "False"
    ? redbreaker
    : offTag?.value === "False" && onTag?.value === "False"&& tripTag?.value === "False"
    ?whitebreaker
    : redbreaker; // default (if none matches)
    
     return(
<div>
<img src={imgSrc} alt="Red Breaker3" className="rewa_redbreaker3-pump"style={{
         top:'63%',
         left:'7.3%'
    }} />
</div>
     )
 })}

{["PMP2"].map((breakerName)=>{
     const tags = PumpData.filter((t: any) => t.name.startsWith(breakerName));
     const onTag = tags.find(t => t.name === `${breakerName}_ON`);
  const tripTag = tags.find(t => t.name === `${breakerName}_ANYFLT`);
  const offTag = tags.find(t => t.name === `${breakerName}_OFF`);
console.log(onTag)
let imgSrc =
  onTag?.value === "True" && offTag?.value==="False" && tripTag?.value === "False"
    ? greenbreaker
    : tripTag?.value === "True"
    ? yellowbreaker
    : offTag?.value === "True" && onTag?.value === "False"&& tripTag?.value === "False"
    ? redbreaker
    : offTag?.value === "False" && onTag?.value === "False"&& tripTag?.value === "False"
    ?whitebreaker
    : redbreaker; // default (if none matches)
     return(
    <div>
    <img src={imgSrc} alt="Red Breaker4" className="rewa_redbreaker4-pump"style={{
         top:'63%',
         left:'17.5%'
    }}/>

    </div>
     )
})}

{["PMP3"].map((breakerName)=>{
     const tags = PumpData.filter((t: any) => t.name.startsWith(breakerName));
     const onTag = tags.find(t => t.name === `${breakerName}_ON`);
  const tripTag = tags.find(t => t.name === `${breakerName}_ANYFLT`);
  const offTag = tags.find(t => t.name === `${breakerName}_OFF`);
console.log(onTag)
let imgSrc =
  onTag?.value === "True" && offTag?.value==="False" && tripTag?.value === "False"
    ? greenbreaker
    : tripTag?.value === "True"
    ?  yellowbreaker
    : offTag?.value === "True" && onTag?.value === "False"&& tripTag?.value === "False"
    ? redbreaker
    : offTag?.value === "False" && onTag?.value === "False"&& tripTag?.value === "False"
    ?whitebreaker
    : redbreaker; // default (if none matches)
     return(
    <div>
    <img src={imgSrc} alt="Red Breaker5" className="rewa_redbreaker5-pump"style={{
         top:'63%',
         left:'31.6%'
    }}/>

    </div>
     )
})}

{["PMP4"].map((breakerName)=>{
     const tags = PumpData.filter((t: any) => t.name.startsWith(breakerName));
     const onTag = tags.find(t => t.name === `${breakerName}_ON`);
  const tripTag = tags.find(t => t.name === `${breakerName}_ANYFLT`);
  const offTag = tags.find(t => t.name === `${breakerName}_OFF`);
console.log(onTag)
let imgSrc =
  onTag?.value === "True" && offTag?.value==="False" && tripTag?.value === "False"
    ? greenbreaker
    : tripTag?.value === "True"
    ?yellowbreaker
    : offTag?.value === "True" && onTag?.value === "False"&& tripTag?.value === "False"
    ? redbreaker
    : offTag?.value === "False" && onTag?.value === "False"&& tripTag?.value === "False"
    ?whitebreaker
    : redbreaker; // default (if none matches)
     return(
    <div>
    <img src={imgSrc} alt="Red Breaker6" className="rewa_redbreaker6-pump"style={{
         top:'63%',
         left:'47.9%'
    }}/>

    </div>
     )
})}

{["PMP5"].map((breakerName)=>{
     const tags = PumpData.filter((t: any) => t.name.startsWith(breakerName));
     const onTag = tags.find(t => t.name === `${breakerName}_ON`);
  const tripTag = tags.find(t => t.name === `${breakerName}_ANYFLT`);
  const offTag = tags.find(t => t.name === `${breakerName}_OFF`);
console.log(onTag)
let imgSrc =
  onTag?.value === "True" && offTag?.value==="False" && tripTag?.value === "False"
    ? greenbreaker
    : tripTag?.value === "True"
    ?  yellowbreaker
    : offTag?.value === "True" && onTag?.value === "False"&& tripTag?.value === "False"
    ? redbreaker
    : offTag?.value === "False" && onTag?.value === "False"&& tripTag?.value === "False"
    ?whitebreaker
    : redbreaker; // default (if none matches)
     return(
    <div>
    <img src={imgSrc} alt="Red Breaker7" className="rewa_redbreaker7-pump"style={{
         top:'63%',
         left:'58%'
    }}/>

    </div>
     )
})}

{["LT2"].map((breakerName)=>{
     const tags = PumpData.filter((t: any) => t.name.startsWith(breakerName));
     const onTag = tags.find(t => t.name === `${breakerName}_ON`);
  const tripTag = tags.find(t => t.name === `${breakerName}_ANYFLT`);
  const offTag = tags.find(t => t.name === `${breakerName}_OFF`);
console.log(onTag)
let imgSrc =
  onTag?.value === "True" && offTag?.value==="False" && tripTag?.value === "False"
    ? greenbreaker
    : tripTag?.value === "True"
    ?  yellowbreaker
    : offTag?.value === "True" && onTag?.value === "False"&& tripTag?.value === "False"
    ? redbreaker
    : offTag?.value === "False" && onTag?.value === "False"&& tripTag?.value === "False"
    ?whitebreaker
    : redbreaker; // default (if none matches)
     return(
    <div>
    <img src={imgSrc} alt="Red Breaker8" className="rewa_redbreaker8-pump"
    style={{
        top:'63%',
        left:'87.2%'
   }}/>

   </div>
     )
})}
   {['LT_BC'].map((breakerName)=>{
   const tags = PumpData.filter((t:any)=>t.name.startsWith(breakerName));
   const onTag = tags.find(t => t.name === `${breakerName}_ON`);
  const tripTag = tags.find(t => t.name === `${breakerName}_ANYFLT`);
  const offTag = tags.find(t => t.name === `${breakerName}_OFF`);
console.log(onTag)
let imgSrc =
  onTag?.value === "True" && offTag?.value==="False" && tripTag?.value === "False"
    ? greenbreaker
    : tripTag?.value === "True"
    ?  yellowbreaker
    : offTag?.value === "True" && onTag?.value === "False"&& tripTag?.value === "False"
    ? redbreaker
    : offTag?.value === "False" && onTag?.value === "False"&& tripTag?.value === "False"
    ?whitebreaker
    : redbreaker; // default (if none matches)
   return(
   <div>
    <img src={imgSrc} alt="Red Breaker9" className="rewa_redbreaker9-pump" style={{
        top:'76.3%',
        left:'78.3%'
   }}/>
   </div>
   )
   })}

    <div className="Mfm_132kv">33KV OVERHEAD TRANSMISSION LINE</div>
    <div className="INC16_6">33/6.6KV PTX-01</div>
    <div className="POWER_TX1">33KV MAIN MFM</div>
    <div className="INC26_6" >33/6.6KV PTX-02</div>
    <div className="INC36_6"  style={{
        
        left:'82%'
    }}>33/0.433 KV AUX TX</div>
    <div className="POWER_TX2">33KV MAIN INCOMER</div>
    <div className="INC16_7"style={{
        top:'40%'
    }}>6.6KV INC-01 MFM</div>
    <div className="INC26_7" style={{
        top:'40%',
        left:'61%'
    }}>6.6KV INC-02 MFM</div>
    <div className="INC36_7"style={{
        top:'40%',
        left:'84%'
    }}>AUX TX MFM</div>
    <div className="BUSCOUP">BUS COUPLER</div>
    <div className="VT1MFM">VT-1 MFM</div>
    <div className="VT2MFM">VT-2 MFM</div>
    <div className="VT3MFM">VT-3 MFM</div>
    <div className="VT4MFM">VT-4 MFM</div>
    <div className="VT5MFM">VT-5 MFM</div>
    <div className="LTINC1" style={{
         width:'106px',
         left:'74%'
    }}>LT INCOMER-01</div>
    <div className="LTINC2"style={{
         width:'106px',
         left:'91%'
    }}>LT INCOMER-02</div>
    <div className="LTINC1MFM"style={{
         width:'106px',
         left:'71.6%'
    }}>LT MFM-01</div>
    <div className="LTINC2MFM">LT MFM-02</div>
    <div className="LTBUS" style={{
        top:'84%',
        
    }}>LT BUS COUPLER</div>
    <div className="VCB1" style={{
        top:'65%',
        left:'11%'
    }}>VCB-1</div>
    <div className="VCB2"style={{
        top:'65%',
        left:'21%',
       width:'47px'
    }}>VCB-2</div>
    <div className="VCB3" style={{
        top:'65%',
        left:'35%',
       width:'47px'
    }}>VCB-3</div>
    <div className="VCB4"style={{
        top:'65%',
        left:'52%',
        width:'47px'
    }}>VCB-4</div>
    <div className="VCB5"style={{
        top:'63%',
        left:'62%',
        width:'47px'
    }}>VCB-5</div>

    <div>
    <div className="PUMP1_2250" style ={{fontSize:'15px'}}>PUMP-1 418 KW</div>
    <div className="PUMP2_2250"style ={{fontSize:'15px'}}>PUMP-2 418 KW</div>
    <div className="PUMP3_2250"style ={{fontSize:'15px'}}>PUMP-3 418 KW</div>
    <div className="PUMP4_2250"style ={{fontSize:'15px'}}>PUMP-4 418 KW</div>
    <div className="PUMP5_2250"style ={{fontSize:'15px'}}>PUMP-5 418 KW</div>
  </div>
    
 {["KV33_INC1"].map((breakerName) => (
  <div
    key={breakerName}
    className="MFM1_33KV"
    onClick={() => openBreaker(breakerName)}
    style={{ cursor: "pointer" }}
  ></div>
))}

 {["KV6_6_INC1"].map((breakerName) => (
  <div
    key={breakerName}
    className="KV6_6_INC01_MFM"
    onClick={() => openBreaker(breakerName)}
    style={{ cursor: "pointer" }}
  ></div>
))}


 {["KV6_6_INC2"].map((breakerName) => (
  <div
    key={breakerName}
    className="KV6_6_INC02_MFM"
    onClick={() => openBreaker(breakerName)}
    style={{ cursor: "pointer" }}
  ></div>
))}


 {["AUX_TRX1"].map((breakerName) => (
  <div
    key={breakerName}
    className="KV6_6_INC03_MFM"
    onClick={() => openBreaker(breakerName)}
    style={{ cursor: "pointer" }}
  ></div>
))}

 {["LT1"].map((breakerName) => (
  <div
    key={breakerName}
    className="MFM1_INC1"
    onClick={() => openBreaker(breakerName)}
    style={{ cursor: "pointer" }}
  ></div>
))}

 {["LT2"].map((breakerName) => (
  <div
    key={breakerName}
    className="MFM1_INC2"
    onClick={() => openBreaker(breakerName)}
    style={{ cursor: "pointer" }}
  ></div>
))}

 {["PMP1"].map((breakerName) => (
  <div
    key={breakerName}
    className="MTR1_MFM"
    onClick={() => openBreaker(breakerName)}
    style={{ cursor: "pointer" }}
  ></div>
))}



 {["PMP2"].map((breakerName) => (
  <div
    key={breakerName}
    className="MTR2_MFM"
    onClick={() => openBreaker(breakerName)}
    style={{ cursor: "pointer" }}
  ></div>
))}




 {["PMP3"].map((breakerName) => (
  <div
    key={breakerName}
    className="MTR3_MFM"
    onClick={() => openBreaker(breakerName)}
    style={{ cursor: "pointer" }}
  ></div>
))}





 {["PMP4"].map((breakerName) => (
  <div
    key={breakerName}
    className="MTR4_MFM"
    onClick={() => openBreaker(breakerName)}
    style={{ cursor: "pointer" }}
  ></div>
))}





 {["PMP5"].map((breakerName) => (
  <div
    key={breakerName}
    className="MTR5_MFM"
    onClick={() => openBreaker(breakerName)}
    style={{ cursor: "pointer" }}
  ></div>
))} 
     <div className="MTR1txt"></div>
     <div className="MTR2txt"></div>
     <div className="MTR3txt"></div>
     <div className="MTR4txt"></div>
     <div className="MTR5txt"></div>  

    


  <SldPopUp isOpen={breakerOpen} onClose={closeBreaker}
  breakerName={selectedbreakerName || "EOPD1_CLS"}
  container={targetRef.current}/>
  <div className="MTR-pumpOff">
    


{["PMP1"].map((breakerName) => {
  const tags = PumpData.filter((t: any) => t.name.startsWith(breakerName));
  const onTag = tags.find(t => t.name === `${breakerName}_ON`);
  const tripTag = tags.find(t => t.name === `${breakerName}_ANYFLT`);
  const offTag = tags.find(t => t.name === `${breakerName}_OFF`);

  // Determine background color based on the same logic as your imgSrc
  const bgColor =
    onTag?.value === "True" && offTag?.value === "False" && tripTag?.value === "False"
      ? "#4aab00"
      : tripTag?.value === "True"
      ? "yellow"
      : offTag?.value === "True" && onTag?.value === "False" && tripTag?.value === "False"
      ? "red"
      : offTag?.value === "False" && onTag?.value === "False" && tripTag?.value === "False"
      ? "white"
      : "red"; // default

  return (
    <div
      key={breakerName}
      className="MTR1"
      style={{
        top: "85%",
        left: "6.6%",
        position: "absolute",
        borderColor: bgColor,
      }}
    ></div>
  );
})}


{["PMP2"].map((breakerName) => {
  const tags = PumpData.filter((t: any) => t.name.startsWith(breakerName));
  const onTag = tags.find(t => t.name === `${breakerName}_ON`);
  const tripTag = tags.find(t => t.name === `${breakerName}_ANYFLT`);
  const offTag = tags.find(t => t.name === `${breakerName}_OFF`);

  // Determine background color based on the same logic as your imgSrc
  const bgColor =
    onTag?.value === "True" && offTag?.value === "False" && tripTag?.value === "False"
      ? "#4aab00"
      : tripTag?.value === "True"
      ? "yellow"
      : offTag?.value === "True" && onTag?.value === "False" && tripTag?.value === "False"
      ? "red"
      : offTag?.value === "False" && onTag?.value === "False" && tripTag?.value === "False"
      ? "white"
      : "red"; // default

  return (
    <div
      key={breakerName}
      className="MTR2"
      style={{
       top:'85%',
     left: '16.9%',
        position: "absolute",
        borderColor: bgColor,
      }}
    ></div>
  );
})}


{["PMP3"].map((breakerName) => {
  const tags = PumpData.filter((t: any) => t.name.startsWith(breakerName));
  const onTag = tags.find(t => t.name === `${breakerName}_ON`);
  const tripTag = tags.find(t => t.name === `${breakerName}_ANYFLT`);
  const offTag = tags.find(t => t.name === `${breakerName}_OFF`);

  // Determine background color based on the same logic as your imgSrc
  const bgColor =
    onTag?.value === "True" && offTag?.value === "False" && tripTag?.value === "False"
      ? "#4aab00"
      : tripTag?.value === "True"
      ? "yellow"
      : offTag?.value === "True" && onTag?.value === "False" && tripTag?.value === "False"
      ? "red"
      : offTag?.value === "False" && onTag?.value === "False" && tripTag?.value === "False"
      ? "white"
      : "red"; // default

  return (
    <div
      key={breakerName}
      className="MTR3"
      style={{
 top:'85%',
     left: '31%',
        position: "absolute",
        borderColor: bgColor,
      }}
    ></div>
  );
})}

{["PMP4"].map((breakerName) => {
  const tags = PumpData.filter((t: any) => t.name.startsWith(breakerName));
  const onTag = tags.find(t => t.name === `${breakerName}_ON`);
  const tripTag = tags.find(t => t.name === `${breakerName}_ANYFLT`);
  const offTag = tags.find(t => t.name === `${breakerName}_OFF`);

  // Determine background color based on the same logic as your imgSrc
  const bgColor =
    onTag?.value === "True" && offTag?.value === "False" && tripTag?.value === "False"
      ? "#4aab00"
      : tripTag?.value === "True"
      ? "yellow"
      : offTag?.value === "True" && onTag?.value === "False" && tripTag?.value === "False"
      ? "red"
      : offTag?.value === "False" && onTag?.value === "False" && tripTag?.value === "False"
      ? "white"
      : "red"; // default

  return (
    <div
      key={breakerName}
      className="MTR4"
      style={{
  top:'85%',
     left:'47.4%',
        position: "absolute",
        borderColor: bgColor,
      }}
    ></div>
  );
})}

{["PMP5"].map((breakerName) => {
  const tags = PumpData.filter((t: any) => t.name.startsWith(breakerName));
  const onTag = tags.find(t => t.name === `${breakerName}_ON`);
  const tripTag = tags.find(t => t.name === `${breakerName}_ANYFLT`);
  const offTag = tags.find(t => t.name === `${breakerName}_OFF`);

  // Determine background color based on the same logic as your imgSrc
  const bgColor =
    onTag?.value === "True" && offTag?.value === "False" && tripTag?.value === "False"
      ? "#4aab00"
      : tripTag?.value === "True"
      ? "yellow"
      : offTag?.value === "True" && onTag?.value === "False" && tripTag?.value === "False"
      ? "red"
      : offTag?.value === "False" && onTag?.value === "False" && tripTag?.value === "False"
      ? "white"
      : "red"; // default

  return (
    <div
      key={breakerName}
      className="MTR5"
      style={{
  top:'85%',
     left: '57.5%',
        position: "absolute",
        borderColor: bgColor,
      }}
    ></div>
  );
})}



  </div>
  </div>

    </>
}

    </>
    );

};
export default SLD;
